<template>
  <tr class="bg-white">

    <td colspan="7" class="relative">


      <table class="w-full table-background">
        <tbody>
        <tr>
          <td colspan="7" class="pl-2 py-6">
            <div class="w-full flex lg:flex-nowrap relative">

              <h2 class="
                  week-cycle-fontsize week-cycle-color
                  font-bold
                  pr-6
                  uppercase
                  
                ">
                <i class="fa fa-circle  h-2 w-2" v-if="weeks.menuCycle"
                  :class="(weeks.menuCycle && (weeks.menuCycle.is_guidline && weeks.menuCycle.is_additional)) ? 'online-color' : 'offline-color'"
                  aria-hidden="true"></i>&nbsp;&nbsp;Week of {{ weeks.days[0].date }}
                <br>
                <a class="ml-3 underline arrow-color" target='_blank'
                  v-if="weeks.menuCycle && weeks.menuCycle.source != null"
                  :href="route('menu-cycle-edit', weeks.menuCycle.source_id) + '?month=' + searchForm.month + '&year=' + searchForm.year + '&mealtype=' + searchForm.meal_type + '&agerange=' + searchForm.age_grade_offering + '&site=' + searchForm.site + '&type=' + searchForm.type + '&days=' + searchForm.day + '&is_update=' + 1 + '&weekDate=' + weeks.days[0].date">
                  {{ weeks.menuCycle.source.name }} </a>
              </h2>
              <a href="javascript:void(0)" v-if="showImport && isMenuPlanner" @click="isShowImportData = true"
                class="underline p-color p-size">Import Menu Week</a>

              <inertia-link v-if="showImport && isMenuPlanner"
                :href="route('menu-cycle-add') + '?month=' + searchForm.month + '&year=' + searchForm.year + '&mealtype=' + searchForm.meal_type + '&agerange=' + searchForm.age_grade_offering + '&days=' + searchForm.day + '&site=' + searchForm.site + '&guide_line_id=' + searchForm.guide_line_id + '&weekNumber=' + index + '&type=' + searchForm.type + '&weekDate=' + weeks.days[0].date + '&offering_id=' + searchForm.offering_id"
                class="pl-4 underline p-color p-size">Add Meals to Week</inertia-link>



              <a href="javascript:void(0)" v-if="isExcludedWeek() && weeks.menuCycle"
                class="week-cycle-fontsize week-cycle-color font-bold pr-6 uppercase ml-5 underline arrow-color"
                @click="is_update_guideline = 1">{{
                  weeks?.menuCycle?.guideline?.name }}</a>

              <UpdateGuildeline v-if="is_update_guideline" @closeModal="is_update_guideline = 0"
                :menuCycle="weeks?.menuCycle" :graderanges="graderanges" :mealTypeImport="mealTypeImport"
                :daysImport="daysData" @loadMenuCycle="loadMenuCycle" @loadCalendar="loadCalendar" />

              <ImportWeekCycle v-if="isShowImportData" @loadCalendar="loadCalendar" @loadMenuCycle="loadMenuCycle"
                @closeModal="isShowImportData = false" :daysImport="daysImport" :mealTypeImport="mealTypeImport"
                :graderangesImport="graderanges" :weeks="weeks" :searchForm="searchForm" :weekIndex="index" :sites="sites"
                :users="users" />

              <MenuWeek :week="this.index" :week_date="weeks.days[0].date" v-if="weeks.menuCycle" :searchForm="searchForm"
                :menuCycle="weeks.menuCycle" :isExcludedWeek="isExcludedWeek()" />

            </div>
          </td>
        </tr>
        <tr>
          <calendar-day v-for="(day, index) in weeks.days" :day="day" :index="index" :menuCycle="weeks.menuCycle"
            :searchForm="searchForm" @copyData="copyData" :copiedDataId="copiedDataId" @loadCalendar="loadCalendar"
            :week="this.index" :excludeDays="excludeDays" @loadExcludedDateDataOnLoad="loadExcludedDateDataOnLoad"
            :isMenuPlanner="isMenuPlanner" :site="site" :alreadyAddedCartData="alreadyAddedCartData"
            @loadAlreadyAddedCartData="loadAlreadyAddedCartData"></calendar-day>
        </tr>
      </tbody>
      </table>

      <div v-if="is_loading"
        class="absolute top-0 left-0 right-0 bottom-0 p-6 bg-white flex justify-center items-center bg-opacity-50">
        <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill" />
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    </td>
  </tr>
</template>
<style>
.fill-blue-600 {
  fill: #1c64f2;
}
</style>
<script>
import CalendarDay from "@/Pages/Calendar/CalendarDay";
import MenuWeek from "@/Pages/Calendar/MenuWeek";
import ImportWeekCycle from "@/Pages/Calendar/Elements/ImportWeekCycle";
import UpdateGuildeline from "@/Pages/Calendar/Elements/UpdateGuildeline";

export default {
  props: ["weeks", "searchForm", "index", "daysImport", "graderanges", "mealTypeImport", "copiedDataId", "excludeDays", "isMenuPlanner", "users", "is_loading", "daysData", 'alreadyAddedCartData', 'isAllowImportPastWeek'],
  components: {
    CalendarDay,
    MenuWeek,
    ImportWeekCycle,
    UpdateGuildeline
  },
  computed: {
    showImport: function () {
      if (this.weeks.days[6].is_past) {
        if (!this.weeks.menuCycle) {
          return true;
        } else {
          return false;
        }
      } else {
        if(this.isAllowImportPastWeek) {
          if (!this.weeks.menuCycle) {
          return true;
        } else {
          return false;
        }
        } else {
          return false;
        }        
      }
    }
  },
  data() {
    return {
      isShowImportData: false,
      log: console.log,
      is_update_guideline: false
    }
  },
  methods: {

    isExcludedWeek() {
      let excludeDays = this.excludeDays;
      let days = this.weeks.days;
      const normalizeDate = (dateStr) => {
        const [month, day, year] = dateStr.includes('/') ? dateStr.split('/') : dateStr.split('-');
        return `${month}-${day}-${year}`;
      };

      // Create an array of normalized excluded dates
      const excludedDates = excludeDays.map(item => normalizeDate(item.date));
      // Check each date in the days array
      return days.some(dayItem => {
        const normalizedDayDate = normalizeDate(dayItem.date);
        return excludedDates.includes(normalizedDayDate);
      });
    },

    loadCalendar() {
      this.$emit('loadCalendar');
    },
    loadAlreadyAddedCartData() {
      this.$emit('loadAlreadyAddedCartData');
    },
    loadExcludedDateDataOnLoad(site, guide_line_id) {
      this.$emit('loadExcludedDateDataOnLoad', site, guide_line_id);
    },
    copyData(id) {
      this.$emit('copyData', id);
    }

  }
};
</script>
